export type JobAdsSearchParams = {
  candidacyTypes: string[]
  companyBusinessTypes: string[]
  companySectors: string[]
  contractDurations: string[]
  contractTypes: string[]
  exclusive: string[]
  isAbroadOnly: boolean
  isSavedSearch: boolean
  jobWithImpact: string
  lat: string | null
  lng: string | null
  locales: string[]
  location: string | null
  locations: string[]
  page: number
  positionCategories: string[]
  radius: number | null
  remoteTypes: string[]
  sort: string | null
  startDates: string[]
  studyLevels: string[]
  tags: string[]
  userQuery: string
  workExperiences: string[]
}

export const getJobAdsSearchParamsFromURLSearchParams = (searchParams: URLSearchParams): JobAdsSearchParams => {
  const sort = searchParams.get("sort")

  const page = Math.max((Number(searchParams.get("page")) || 0) - 1, 0)
  const userQuery = searchParams.get("q")?.trim() || ""
  const lat = searchParams.get("lat")
  const lng = searchParams.get("lng")
  const radius = Number(searchParams.get("radius")) || null
  const isAbroadOnly = searchParams.get("abroad_only") === "true"
  const jobWithImpact = searchParams.get("job_with_impact") || ""

  const contractDurations = searchParams.getAll("contract_duration")
  const contractTypes = searchParams.getAll("contract")
  const locations = searchParams.getAll("location")
  const location = searchParams.get("location")
  const positionCategories = searchParams.getAll("position_category_uuid")
  const startDates = searchParams.getAll("start_date")
  const studyLevels = searchParams.getAll("study_levels")
  const exclusive = searchParams.getAll("exclusive")
  const tags = searchParams.getAll("tags")
  const locales = searchParams.getAll("locale")
  const companySectors = searchParams.getAll("company_sectors")
  const workExperiences = searchParams.getAll("work_experience_code")
  const remoteTypes = searchParams.getAll("remote_types")
  const companyBusinessTypes = searchParams.getAll("company_business_type")
  const candidacyTypes = searchParams.getAll("candidacy_type")

  const isSavedSearch = searchParams.get("saved_search") === "true"

  return {
    candidacyTypes,
    companyBusinessTypes,
    companySectors,
    contractDurations,
    contractTypes,
    exclusive,
    isAbroadOnly,
    isSavedSearch,
    jobWithImpact,
    lat,
    lng,
    locales,
    location,
    locations,
    page,
    positionCategories,
    radius,
    remoteTypes,
    sort,
    startDates,
    studyLevels,
    tags,
    userQuery,
    workExperiences,
  }
}
